import React, { createContext, useContext, useState, useEffect } from "react";
import { setLogoutHandler } from "../services/apiService";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = sessionStorage.getItem("user");
    return saved ? JSON.parse(saved) : null;
  });

  const [permissions, setPermissions] = useState(() => {
    const saved = sessionStorage.getItem("permissions");
    return saved ? JSON.parse(saved) : [];
  });

  // Save user in session storage
  useEffect(() => {
    if (user) {
      sessionStorage.setItem("user", JSON.stringify(user));
    } else {
      sessionStorage.removeItem("user");
    }
  }, [user]);

  // Save permissions in session storage
  useEffect(() => {
    if (permissions.length > 0) {
      sessionStorage.setItem(
        "permissions",
        JSON.stringify(permissions)
      );
    } else {
      sessionStorage.removeItem("permissions");
    }
  }, [permissions]);

  // LOGIN
  const login = (data) => {
    localStorage.setItem("jwt_token", data.access_token);

    const userObj = {
      userId: data.user_id,
      name: data.name,
      email: data.email,
      role_name: data.role_name,
      role_id: data.role_id,
      IsLoggedIn: true,
    };

    setUser(userObj);

    // Admin gets all permissions
    if (data.role_name === "Admin" || data.role_id === 1) {
      setPermissions(["*"]);
    }

    // Verifier gets User Management permission
    else if (data.role_name === "VERIFIER") {
      setPermissions([
        ...(data.userAccess || []),
        "VIEW_USER_MANAGEMENT",
        "ADD_PROPERTY",
      ]);
    }

    // Other users get permissions from backend
    else {
      setPermissions(data.userAccess || []);
    }
  };

  // LOGOUT
  const logout = () => {
    setUser(null);
    setPermissions([]);
    localStorage.removeItem("jwt_token");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("permissions");
  };

  // Set logout handler
  useEffect(() => {
    setLogoutHandler(logout);
  }, []);

  return (
    <UserContext.Provider
      value={{
        isLoggedIn: user?.IsLoggedIn,
        user,
        permissions,
        login,
        logout,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);